module.exports = __webpack_public_path__ + "static/media/gory_derevya_dal_sneg_oblaka_115484_1920x1080.b3bef548.jpg";